import { baseApi } from './base.api'

export const reportesCumplimientoApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    /**
     * Contrato HTTP para evidencias/reportes asociados a autorizaciones, tareas o condicionantes.
     * `guardarReportes` recibe FormData, por eso no se transforma a snake_case.
     */
    recuperarReportesPorIdRelacionado: builder.mutation({
      query: (idRelacionado) => {
        return {
          url: `${window._env_.API_CONTEXTO_REPORTES_CUMPLIMIENTO}/relacionado/${idRelacionado}`,
          method: 'GET',
        }
      },
    }),
    guardarReportes: builder.mutation({
      query: (formData) => {
        return {
          url: `${window._env_.API_CONTEXTO_REPORTES_CUMPLIMIENTO}`,
          method: 'POST',
          body: formData,
        }
      },
    }),
    eliminarReportePorId: builder.mutation({
      query: (idReporte) => {
        return {
          url: `${window._env_.API_CONTEXTO_REPORTES_CUMPLIMIENTO}/${idReporte}`,
          method: 'DELETE',
        }
      },
    }),
  }),
})

export const {
  useGuardarReportesMutation,
  useEliminarReportePorIdMutation,
  useRecuperarReportesPorIdRelacionadoMutation,
} = reportesCumplimientoApi
